import { BackupCodesLayout } from '@/components';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import type { DialogProps } from '@/components/dialog/useDialogWithExtraProps';
import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { Modal } from '@/components/modal/Modal';
import { Typography } from '@/components/typography';
import { Flex, message } from 'antd';
import { ThreeColumnActions } from '@/components/layouting';
import type { FC } from 'react';
import { BackupCodes as messages } from '../messages';
import { FormattedMessage, useIntl } from '@/components/formatted_message/FormattedMessage';

const { Paragraph } = Typography;

export interface BackupCodesModalProps extends DialogProps {
  backupCodes: string[];
  onContinue: () => void;
}

export const BackupCodesModal: FC<BackupCodesModalProps> = ({ backupCodes, onClose, onContinue }) => {
  const intl = useIntl();

  const handleCopyBackupCodes = async () => {
    if (!backupCodes.length) {
      return;
    }

    await navigator.clipboard.writeText(backupCodes.join('\n'));
    message.success(intl.formatMessage(messages.codesCopiedToClipboard));
  };

  return (
    <Modal
      destroyOnHidden
      open
      data-cy="backup-codes-modal"
      footer={
        <ThreeColumnActions
          left={
            <ButtonAnt onClick={onClose}>
              <FormattedMessage {...messages.close} />
            </ButtonAnt>
          }
          center={
            <ButtonAnt onClick={handleCopyBackupCodes}>
              <FormattedMessage {...TRANSLATED_ACTIONS.copy} />
            </ButtonAnt>
          }
          right={
            <ButtonAnt type="primary" onClick={onContinue}>
              <FormattedMessage {...messages.continue} />
            </ButtonAnt>
          }
        />
      }
      maxWidth={480}
      title={<FormattedMessage {...messages.title} />}
      onCancel={onClose}
    >
      <Flex vertical gap={8}>
        <Paragraph>
          <FormattedMessage {...messages.description} />
        </Paragraph>
        <BackupCodesLayout backupCodes={backupCodes} />
      </Flex>
    </Modal>
  );
};
